/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Jul 13 2022
*  File : LocalStorageAsyncController.ts
*******************************************/

import { AsyncStorageController, LocalStorageSyncController } from "@ciaopeople/cp-shatsu/Storage";
import { isLocalStorageAvailable } from "../utils/functions.js";

export class LocalStorageAsyncController implements AsyncStorageController<string> {

    private realController: LocalStorageSyncController;
    private enabled: boolean;

    constructor() {
        this.enabled = isLocalStorageAvailable();
        this.realController = new LocalStorageSyncController();
    }
    getStoredData<T>(key: string): Promise<T> {
        if (this.enabled) {
            return Promise.resolve(this.realController.getStoredData(key));
        }
        else {
            return Promise.reject("Local storage is not available");
        }
    }
    setStoredData<T>(key: string, value: T): Promise<void> {
        if (this.enabled) {
            this.realController.setStoredData(key, value);
            return Promise.resolve();
        }
        else {
            return Promise.reject("Local storage is not available");
        }
    }
    deleteStoredData(key: string): Promise<void> {
        if (this.enabled) {
            this.realController.deleteStoredData(key);
            return Promise.resolve();
        }
        else {
            return Promise.reject("Local storage is not available");
        }
    }


}